"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Injects a new element between all existing elements in an array
 * The default injected value is 0, but override with whatever you need
 * @param arrayToIntersperse
 * @param intersperseWith
 */
exports.default = (arrayToIntersperse, intersperseWith = 0) => {
    return arrayToIntersperse.reduce((previousValue, currentValue) => previousValue.concat(currentValue, intersperseWith), [intersperseWith])
        .slice(1, -1);
};
